import React, {Component} from 'react';
import {FaIcon} from "../FaIcon";

export class UpdateItemsInListIcon extends Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    render() {
        return (
            <div className="bu-cell-button">
                <button className={this.cssClassName()} onClick={(event) => this.handleClick(event)}>
                    <FaIcon type="button" iconName="sync-alt" spin={this.props.isBeingSyncedOnDemand}/>
                </button>
                <div className="bu-tooltip">
                    <button className={this.cssClassName()} onClick={(event) => this.handleClick(event)}>
                        <FaIcon type="button" iconName="sync-alt" spin={this.props.isBeingSyncedOnDemand}/>
                    </button>
                    <p className="tooltip-description">
                        {this.props.message}
                    </p>
                </div>
            </div>
        )
    }

    handleClick(event) {
        event.preventDefault();
        this.props.onClick()
    }

    cssClassName() {
        return "not-synced"
    }
}